import { useTheme } from '@emotion/react';
import { IconGrabber, IconClose } from '@hubble/icons';
import { forwardRef } from 'react';
import { StyledControlButton } from './styles.js';
import { jsx } from '@emotion/react/jsx-runtime';

const ControlButton = forwardRef(({
  activeStyle,
  ariaLabel,
  className,
  cursor,
  icon,
  size = 'md',
  style,
  ...props
}, ref) => {
  return jsx(StyledControlButton, {
    ref: ref,
    ...props,
    className: className,
    tabIndex: 0,
    "aria-label": ariaLabel,
    icon: icon,
    activeStyle: activeStyle,
    size: size,
    style: {
      ...style,
      cursor
    }
  });
});
const DragHandle = forwardRef((props, ref) => {
  const theme = useTheme();
  return jsx(ControlButton, {
    cursor: "grab",
    icon: jsx(IconGrabber, {
      color: theme.colorScheme.content.secondary
    }),
    ref: ref,
    ...props
  });
});
const RemoveButton = forwardRef((props, ref) => {
  const theme = useTheme();
  return jsx(ControlButton, {
    className: "remove-drag-item",
    icon: jsx(IconClose, {
      size: "xs",
      color: theme.colorScheme.content.secondary
    }),
    activeStyle: {
      fill: 'rgba(255, 70, 70, 0.95)',
      background: 'rgba(255, 70, 70, 0.1)'
    },
    hidden: true,
    ref: ref,
    ...props
  });
});

export { ControlButton, DragHandle, RemoveButton };
